import { render, staticRenderFns } from "./bindStudentView.vue?vue&type=template&id=31c17fc6&"
import script from "./bindStudentView.vue?vue&type=script&lang=js&"
export * from "./bindStudentView.vue?vue&type=script&lang=js&"
import style0 from "./bindStudentView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports